const routes =
[
    // {
    //     path: '/',
    //     redirect: '/login',
    // },

    {
        path: '/login',
        component: () => import('pages/Login.vue'),
    },

    {
        path: '/',
        component: () => import('layouts/MainLayout.vue'),
        children:
        [
          { path: '', component: () => import('pages/IndexPage.vue') }
        ]
    },

    // Always leave this as last one,
    // but you can also remove it
    {
        path: '/:catchAll(.*)*',
        component: () => import('pages/ErrorNotFound.vue')
    }
]

export default routes
